import AuthLayout from "../../layout/auth/auth";
import {Route, Routes} from "react-router-dom";
import Login from "./Login/Login";
import ForgetPassword from "./ForgetPassoword/ForgetPassword";
import NewPassword from "./ForgetPassoword/NewPassword";
import OTP from "./ForgetPassoword/OTP";
import SignUp from "./SignUp/SignUp";

export default function AuthEntry({className, ...props}) {

    return (
        <div className={"h-[100vh]"}>
        <AuthLayout>
            <Routes>
                <Route path="/login" element={<Login/>}/>
                <Route path="/sign-up" element={<SignUp/>}/>
                <Route path="/forget-password" element={<ForgetPassword/>}/>
                <Route path="/otp" element={<OTP/>}/>
                <Route path="/new-password" element={<NewPassword/>}/>

            </Routes>


        </AuthLayout>
        </div>

    )
}